var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zixingbianxi-page"},[_c('navBar',{on:{"goBack":_vm.gobackChapter}},[_c('span',{staticClass:"title"},[_vm._v("字形辨析")])]),_c('div',{staticClass:"content-box"},[_c('baseChoose',{attrs:{"questionType":2,"zixingbianxi":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }